import mutations from './item/mutations';
import actions from './item/actions';

const item = {
  namespaced: true,
  state: {
    item: {
      logo: null,
      name: null,
    },
    isLoading: false,
  },
  mutations,
  actions,
};

export default item;
